module.exports = __webpack_public_path__ + "img/1388458851.771de68f.jpg";